import { OreStack } from "@edenredespana/oreneta"
import { useHelpCenter } from "@/HelpCenter/ui/context"
import {
    NewTicketHeader,
    NewTicketFooter,
    NewTicketStep1,
    NewTicketStep2,
    NewTicketStep3,
    NewTicketStep4,
    NewTicketCancelModal,
    NewTicketInvoiceModal,
    NewTicketBankAccountModal,
    NewTicketTPVModal,
    NewTicketMaterialModal
} from '@/HelpCenter/ui/molecules'

export const NewTicketFormContainer = () => {
    const { 
        step, 
        setIsModalOpen, 
        isModalOpen, 
        isInvoiceModalOpen, 
        setIsInvoiceModalOpen,
        isBankAccountModalOpen,
        setIsBankAccountModalOpen,
        isTPVModalOpen,
        setIsTPVModalOpen,
        isMaterialModalOpen,
        setIsMaterialModalOpen
     } = useHelpCenter()
    const getStep = () => {
        switch (step) {
            case 1:
                return <NewTicketStep1 />
            case 2:
                return <NewTicketStep2 />
            case 3:
                return <NewTicketStep3 />
            case 4:
                return <NewTicketStep4 />
            default:
                return <NewTicketStep1 />
        }
    }


    return (
        <>
        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            <OreStack space="medium" placeContent="stretch">
                <NewTicketHeader step={step} setIsModalOpen={setIsModalOpen} />
                {getStep()}
                <NewTicketFooter />
            </OreStack>
        </div>
        <NewTicketCancelModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
        <NewTicketInvoiceModal isModalOpen={isInvoiceModalOpen} setIsModalOpen={setIsInvoiceModalOpen} />
        <NewTicketBankAccountModal isModalOpen={isBankAccountModalOpen} setIsModalOpen={setIsBankAccountModalOpen} />
        <NewTicketTPVModal isModalOpen={isTPVModalOpen} setIsModalOpen={setIsTPVModalOpen} />
        <NewTicketMaterialModal isModalOpen={isMaterialModalOpen} setIsModalOpen={setIsMaterialModalOpen} />
        </>
    )
}